export default "__VITE_ASSET__e7d00aaf__"